import { defineMessages } from 'react-intl';

export const enableServiceModalMessages = defineMessages({
  title: {
    id: 'manage-services.class-list.enable-service-confirmation-modal.title',
    defaultMessage: 'Contact us to set up pricing for this service',
  },
  body: {
    id: 'manage-services.class-list.enable-service-confirmation-modal.body',
    defaultMessage:
      'In order to ensure accurate payouts for this service, please contact us to set up pricing. Our team can help configure this for all services you’d like to enable for ClassPass members.',
  },
  cancel: {
    id: 'manage-services.class-list.enable-service-confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  contactUs: {
    id: 'manage-services.class-list.enable-service-confirmation-modal.contact-us',
    defaultMessage: 'Contact Us',
  },
});

export default defineMessages({
  title: {
    id: 'manage-services.class-list.title',
    defaultMessage: 'Services',
  },
  noServices: {
    id: 'manage-services.class-list.no-services',
    defaultMessage: 'You have no services associated with this venue',
  },
  updateActionSuccess: {
    id: 'manage-services.class-list.update-action-success',
    defaultMessage: 'Service has been successfully updated',
  },
  updateActionFailure: {
    id: 'manage-services.class-list.update-action-failure',
    defaultMessage: 'There was a problem with your request',
  },
  confirmClassesHeader: {
    id: 'class-list.confirm-classes-header',
    defaultMessage: 'Confirm your classes',
  },
  confirmClassesDescription: {
    id: 'class-list.confirm-classes-description',
    defaultMessage:
      'These classes are currently enabled for when you go live. You can disable any class by toggling it off.',
  },
  editclassesHeader: {
    id: 'class-list.edit-classes-header',
    defaultMessage: 'Edit your descriptions',
  },
});
